import { useAdminsSearch, useMemberSearch } from ".";
import { filterTypes, unassignedOption } from "../constants";
import { map, without, uniqBy, compact } from "lodash";
import { useCurrentUser } from "../contexts/current-user-context";
import { useTasks } from "../contexts/tasks-context";
import { translate } from "@td/shared_utils";

const useFiltersPreload = () => {
  const currentUser = useCurrentUser();
  const { loadAdmins } = useAdminsSearch();
  const { findMember } = useMemberSearch();
  const { filters, initializeFilters } = useTasks();

  const preloadAssignees = async () => {
    const ids = without(
      map(filters[filterTypes.ASSIGNEES], "value"),
      currentUser.id,
      unassignedOption.value,
    );

    if (!ids.length) {
      return filters[filterTypes.ASSIGNEES];
    }

    const admins = await loadAdmins({ ids }, ids.length);

    return uniqBy([
      ...map(admins, ({ id, name }) => ({ value: parseInt(id), label: name })),
      ...filters[filterTypes.ASSIGNEES],
    ], "value");
  };

  const preloadMembers = async () => {
    const members = await Promise.all(
      filters[filterTypes.MEMBERS].map(async ({ value }) => await findMember(value))
    );

    return compact(members).map(({ id, name }) => ({
      value: parseInt(id),
      label: translate(null, "care_team_tasks.filters.fields.member.option", "label", { name, id }),
    }));
  };

  const preloadFilters = async () => {
    initializeFilters({
      [filterTypes.ASSIGNEES]: await preloadAssignees(),
      [filterTypes.MEMBERS]: await preloadMembers(),
    });
  };

  return {
    preloadFilters,
  };
};

export default useFiltersPreload;
